/**
 * DNS domain-ownership validation contract (`/api/dnsvalidation/*`).
 *
 * Shared: both portals run the SAME ownership proof — it is the precondition for a company
 * account, and in Phoenix additionally for ordering a backup environment (the site's technical
 * prefix is derived from the verified domain).
 */
export enum DnsValidationStatus {
  NotRequired = 0,
  Pending = 2,
  Success = 3,
  Failed = 4,
}

export interface DnsValidationRequest {
  domain: string;
}

export interface DnsValidationResponse {
  isValidationRequired: boolean;
  validationToken: string | null;
  status: DnsValidationStatus;
}

export interface DnsValidationVerifyResponse {
  isValid: boolean;
  status: DnsValidationStatus;
  validationToken: string | null;
  isExpired: boolean;
  errorCode?: string;
}

export interface DomainValidationState {
  isValidationRequired: boolean;
  validationToken?: string;
  canProceed: boolean;
  errorCode?: string;
}

export interface DnsValidationStatusResponse {
  isValidationRequired: boolean;
  isValid: boolean;
  validationToken: string | null;
  status: DnsValidationStatus;
  domain?: string;
}

// Empty response on success (200 OK); error responses use the ErrorResponse structure.
export type DnsValidationCancelResponse = Record<string, never>;
